import React from 'react';
import { BreakpointContext } from 'ctm-util-functions';

// using this HOC to prevent funky snapshots in jest, issue with shallow & Context
const withBreakpoints = (WrappedComponent) => (
    (props) => (
        <BreakpointContext.Consumer>
            {(breakpoint) => <WrappedComponent {...props} breakpoint={breakpoint} />}
        </BreakpointContext.Consumer>
    )
);

export { withBreakpoints };
